import { jsx } from 'react/jsx-runtime';
import { ViewMode } from '@fabric-app/types/resources';
import { useResourceListPreferencesContext } from '../contexts/resourceListContextPreferences.js';
import Select from '@fabric-app/ui/components/Select';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';

const ViewModeSwitcher = () => {
  const { viewMode, availableViewModes, setViewMode } = useResourceListPreferencesContext();
  const { isMobileView } = useResponsive();
  if (isMobileView) {
    return null;
  }
  const modes = ViewMode.filter((mode) => availableViewModes.includes(mode));
  if (modes.length < 2) {
    return null;
  }
  return /* @__PURE__ */ jsx(Select, {
    value: viewMode,
    onChange: (value) => setViewMode(value),
    align: "end",
    triggerProps: {
      "data-testid": "view-mode-switcher"
    },
    children: /* @__PURE__ */ jsx(Select.ItemGroup, {
      children: modes.map((mode) => /* @__PURE__ */ jsx(Select.ItemOption, {
        value: mode,
        "data-testid": `${mode.toLowerCase()}-view-button`,
        children: mode
      }, mode))
    })
  }, "mode");
};

export { ViewModeSwitcher };
//# sourceMappingURL=ViewModeSwitcher.js.map
